import { render } from "./Favorites.vue?vue&type=template&id=43426c8b&scoped=true"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"

import "./Favorites.vue?vue&type=style&index=0&id=43426c8b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43426c8b"]])

export default __exports__